import React from 'react';
import { useIntl } from 'react-intl';
import Chip from '.';
import capitalize from '../../Helpers/StringsFormatting/capitalize';

const StatusChip = React.forwardRef(
  ({ status, alternativeLabel, options, colors, ...props }, ref) => {
    const intl = useIntl();
    const safeStatus = status ?? 'default';
    const baseColorHex =
      colors && colors[safeStatus] ? colors[safeStatus] : undefined;

    const Icon = options[safeStatus] ?? null;
    return (
      <Chip
        {...props}
        ref={ref}
        size="medium"
        icon={Icon ? <Icon style={{ color: 'inherit' }} /> : undefined}
        label={
          alternativeLabel ||
          capitalize(intl.messages[status?.toUpperCase()] || status)
        }
        fontSize="1rem"
        width="100%"
        height="36px"
        color={baseColorHex}
        value={safeStatus}
      />
    );
  }
);

export default StatusChip;
